<template>
  <textarea :id="name" :name="name" class="form-control textarea"></textarea>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      value: {
        type: String,
      },
      configs: {
        type: Object,
        default: () => {
        },
      },
    },
    data() {
      return {
        editorValue: this.value,
      };
    },
    mounted() {
      this.setup();
    },
    methods: {
      setup() {
        let ckEditor = CKEDITOR.replace(this.name, {
          ...this.configs,
        });

        ckEditor.on('change', (e) => {
          let content = CKEDITOR.instances[this.name].getData();
          this.$el.innerHTML = content;

          this.$emit('input', content);
          this.$emit('change', {target: {name: e.editor.name}});

          this.editorValue = content;
        });

        if (this.value) {
          CKEDITOR.instances[this.name].setData(this.value);
        }
      },
    },
    watch: {
      value: function(value) {
        if (value !== this.editorValue) {
          CKEDITOR.instances[this.name].setData(value);
        }
      },
    },
  };
</script>